export default __webpack_public_path__ + "static/media/manageDevices.d09f4c8d.svg";